// import * as t from 'io-ts';
import * as t from 'io-ts';
import { TaggableTypes, TagTypes } from '../../enums';
import { timestampCodec } from '../../validation/codecs';
import { enumCodec } from '../../validation/validator';
import { CallResponseSchema } from '../common/callResponseSchema';

// SQL Record
export const TagRecordSchema = t.type({
    id: t.number,
    created_at: timestampCodec,
    tag: t.string
});
export type TagRecord = t.TypeOf<typeof TagRecordSchema>;

// Insert
export const TagInsertSchema = t.type({
    tag: t.string
});
export type TagInsert = t.TypeOf<typeof TagInsertSchema>;

// Create
export const CreateTagsSchema = t.type({
    tags: t.array(t.string),
    tag_type: enumCodec(TagTypes)
});

// Delete
export const DeleteTagsSchema = t.type({
    tags: t.array(t.string),
    tag_type: enumCodec(TagTypes)
});

// Request
export const RequestTagsSchema = t.partial({
    taggable_type: t.union([enumCodec(TaggableTypes), t.undefined]),
    content_ids: t.union([t.array(t.number), t.undefined]),
    entity_ids: t.union([t.array(t.number), t.undefined]),
});

// Add/Remove
export const AddRemoveTagsSchema = t.intersection([
    t.type({
        action: t.union([t.literal('add'), t.literal('remove')]),
        tags: t.array(t.string),
        taggable_type: enumCodec(TaggableTypes)
    }), 
    t.partial({
        content_ids: t.array(t.number),
        entity_ids: t.array(t.number)
    })
]);

// Client API
export const TagApis = {
    Tags: {
        CreateTags: {
            Name: 'tags-createTags',
            Request: CreateTagsSchema,
            Response: t.intersection([t.type({data: TagRecordSchema}), CallResponseSchema])
        },
        DeleteTags: {
            Name: 'tags-deleteTags',
            Request: DeleteTagsSchema,
            Response: CallResponseSchema
        },
        RequestTags: {
            Name: 'tags-requestTags',
            Request: RequestTagsSchema,
            Response: t.intersection([t.type({data: t.array(TagRecordSchema)}), CallResponseSchema])
        },
        AddRemoveTags: {
            Name: 'tags-addRemoveTags',
            Request: AddRemoveTagsSchema,
            Response: CallResponseSchema
        }
    }
}